import { email } from '@sideway/address';

export const isValidEmail = (emailString) => {
  const filteredEmail = email.isValid(emailString, {
    allowUnicode: false
  });
  return filteredEmail;
};

export default isValidEmail;
